export default __webpack_public_path__ + "static/media/website.1500ed4c.svg";